




export default {
  name: "CommonButton",
  props: { text: String, styleType: String }
};
